const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20cinematic%20scene%20with%20deep%20space%20nebula%20background%2C%20dramatic%20lighting%2C%20cosmic%20color%20palette%20of%20deep%20indigo%20and%20electric%20cyan%2C%20epic%20scale%2C%20movie%20poster%20aesthetic%2C%20immersive%20atmosphere&width=800&height=500&seq=carousel-scifi-01&orientation=landscape',
    tag: '科幻巨制',
    title: '星际穿越：探索未知边界',
    desc: '年度最受期待的科幻大片合集，从虫洞到平行宇宙，带你领略想象力的极限。',
    count: '48部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20scene%20with%20urban%20night%20setting%2C%20explosive%20orange%20and%20amber%20color%20grading%2C%20dynamic%20composition%2C%20intense%20chase%20atmosphere%2C%20cinematic%20photography%20style%2C%20gritty%20textures&width=800&height=500&seq=carousel-action-02&orientation=landscape',
    tag: '动作盛宴',
    title: '肾上腺素飙升的顶级动作片',
    desc: '从街头追逐到高空对决，精选最燃的动作电影，每一秒都让你屏住呼吸。',
    count: '65部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20bright%20comedy%20film%20aesthetic%20with%20golden%20sunlight%2C%20joyful%20and%20playful%20atmosphere%2C%20soft%20pastel%20color%20palette%20of%20yellow%20and%20warm%20peach%2C%20lifestyle%20cinematic%20style%2C%20feel%20good%20vibes&width=800&height=500&seq=carousel-comedy-03&orientation=landscape',
    tag: '喜剧专场',
    title: '笑到停不下来的欢乐片单',
    desc: '治愈不开心，精选国内外高分喜剧，无论独自还是聚会都能找到欢乐。',
    count: '82部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20film%20scene%20with%20foggy%20alley%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20cool%20gray%20and%20deep%20green%20tones%2C%20suspenseful%20composition%2C%20noir%20cinematic%20style%2C%20enigmatic%20shadows&width=800&height=500&seq=carousel-thriller-04&orientation=landscape',
    tag: '悬疑烧脑',
    title: '反转不断的悬疑神作',
    desc: '考验智商的时刻到了，层层反转的悬疑电影让你看到最后一秒才恍然大悟。',
    count: '36部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20sunset%20golden%20hour%20lighting%2C%20soft%20dreamy%20atmosphere%2C%20warm%20rose%20and%20coral%20color%20palette%2C%20elegant%20cinematic%20composition%2C%20tender%20emotional%20mood%2C%20beautiful%20bokeh%20background&width=800&height=500&seq=carousel-romance-05&orientation=landscape',
    tag: '爱情经典',
    title: '触动心弦的浪漫电影',
    desc: '从青涩初恋到白头偕老，最动人的爱情电影陪你度过每一个温柔的夜晚。',
    count: '54部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Stunning%20animation%20film%20visual%20with%20vibrant%20colorful%20fantasy%20world%2C%20hand%20drawn%20texture%20feel%2C%20magical%20atmosphere%2C%20rich%20greens%20and%20warm%20golds%2C%20dreamlike%20composition%2C%20Studio%20Ghibli%20inspired%20aesthetic&width=800&height=500&seq=carousel-anime-06&orientation=landscape',
    tag: '动画世界',
    title: '全球高分动画电影精选',
    desc: '跨越国界的动画艺术，从日系经典到欧美巨制，每一帧都是一幅画。',
    count: '71部精选',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              精选六大主题电影合集，发现你的下一个心头好
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                onClick={(e) => e.preventDefault()}
                className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={`快看影视 - ${item.title}`}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-primary-500/85 backdrop-blur-sm text-white text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2.5 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs">
                      {item.count}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}